import {testIds, vehiclesRoutes} from '@dms/routes';

import {useNavigate, composePath, useRequiredParams} from 'shared/web';

import {RentalVehicleForm} from '../../components/RentalVehicleForm/RentalVehicleForm';
import {RentalVehicleFormMode} from '../../components/RentalVehicleForm/types/RentalVehicleFormMode';

export function EditRentalVehicle() {
  const navigate = useNavigate();
  const {id} = useRequiredParams();

  return (
    <RentalVehicleForm
      mode={RentalVehicleFormMode.EDIT}
      vehicleId={id}
      onDiscard={() => navigate(-1)}
      onSuccess={(newVehicleId) =>
        navigate(composePath(vehiclesRoutes.detail, {params: {id: newVehicleId}}))
      }
      data-testid={testIds.vehicles.editRentalVehicle('create')}
    />
  );
}
